import Nette from 'nette-base-module/js/nette/Nette'

const webalize = function(s) {
  s = s.toLowerCase()
  let res = '', i, ch
  for (i = 0; i < s.length; i++) {
    if (s.charAt(i) === '%') {
      continue
    }
    
    ch = Nette.webalizeTable[s.charAt(i)]
    res += ch ? ch : (/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$&()*+,\-./:;<=>?@[\]^_`{|}~\s§]/.test(s.charAt(i)) === false ? encodeURIComponent(s.charAt(i)) : s.charAt(i))
  }
  return res.replace(/[^a-zA-Z0-9%]+/g, '-').replace(/^-|-$/g, '')
};

export default function imageSizeUrl(image, size, alt = null) {
  const urlParts = [image.original.replace('/original/', `/${size}/`)];
  
  if (alt && alt !== '') {
    urlParts.push(webalize(alt) + '.' + image.ext);
  }

  return urlParts.join('/');
}